var _defs, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _line10, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 240",
    width: 320,
    height: 240,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 24,
    height: 24,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 0 L 0 0 0 24",
    stroke: "#fff",
    strokeOpacity: 0.17,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gm",
    cx: "50%",
    cy: "50%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#fff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gmask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#gm)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5082ef",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#5082ef",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5082ef",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ag",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 5,
    markerHeight: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#5a5a66"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ab",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 5,
    markerHeight: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#5082ef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow-p"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7c6cf0",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#7c6cf0",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7c6cf0",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#g)",
    mask: "url(#gmask)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 69.6,
    y1: 106.6,
    x2: 144.5,
    y2: 101.5,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.45
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 161.3,
    y1: 74.3,
    x2: 219.8,
    y2: 100.2,
    stroke: "#4a4a55",
    strokeWidth: 1.4,
    strokeOpacity: 0.55,
    strokeDasharray: "3 3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 99.8,
    y1: 97.7,
    x2: 69.6,
    y2: 106.6,
    stroke: "#5082ef",
    strokeWidth: 1.4,
    strokeOpacity: 0.55
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 69.6,
    y1: 106.6,
    x2: 82.3,
    y2: 72.8,
    stroke: "#5082ef",
    strokeWidth: 1.4,
    strokeOpacity: 0.55
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 82.3,
    y1: 72.8,
    x2: 99.8,
    y2: 97.7,
    stroke: "#5082ef",
    strokeWidth: 1.4,
    strokeOpacity: 0.55
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 173,
    y1: 101.1,
    x2: 144.5,
    y2: 101.5,
    stroke: "#7c6cf0",
    strokeWidth: 1.4,
    strokeOpacity: 0.45
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 144.5,
    y1: 101.5,
    x2: 161.3,
    y2: 74.3,
    stroke: "#7c6cf0",
    strokeWidth: 1.4,
    strokeOpacity: 0.45
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 161.3,
    y1: 74.3,
    x2: 173,
    y2: 101.1,
    stroke: "#7c6cf0",
    strokeWidth: 1.4,
    strokeOpacity: 0.45
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 251.9,
    y1: 98.3,
    x2: 219.8,
    y2: 100.2,
    stroke: "#4a4a55",
    strokeWidth: 1.4,
    strokeOpacity: 0.5,
    strokeDasharray: "3 3"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 219.8,
    y1: 100.2,
    x2: 230.1,
    y2: 73.3,
    stroke: "#4a4a55",
    strokeWidth: 1.4,
    strokeOpacity: 0.5,
    strokeDasharray: "3 3"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 230.1,
    y1: 73.3,
    x2: 251.9,
    y2: 98.3,
    stroke: "#4a4a55",
    strokeWidth: 1.4,
    strokeOpacity: 0.5,
    strokeDasharray: "3 3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.9,
    cy: 92.4,
    r: 30,
    fill: "url(#glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.2,
    cy: 87.7,
    r: 30,
    fill: "url(#glow-p)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 97.7,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6,
    cy: 106.6,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.3,
    cy: 72.8,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 101.1,
    r: 7,
    fill: "#7c6cf0",
    stroke: "#7c6cf0",
    strokeWidth: 1.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.3,
    cy: 74.3,
    r: 7,
    fill: "#7c6cf0",
    stroke: "#7c6cf0",
    strokeWidth: 1.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 101.5,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.9,
    cy: 98.3,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.3,
    strokeDasharray: "3 3"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.8,
    cy: 100.2,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.3,
    strokeDasharray: "3 3"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.1,
    cy: 73.3,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.3,
    strokeDasharray: "3 3"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 142,
    x2: 170,
    y2: 186,
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 170,
    width: 13,
    height: 8,
    rx: 2,
    fill: "#E07AA5",
    fillOpacity: 0.92
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 164,
    width: 13,
    height: 14,
    rx: 2,
    fill: "#E07AA5",
    fillOpacity: 0.92
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 143.5,
    y: 157,
    width: 13,
    height: 21,
    rx: 2,
    fill: "#E07AA5",
    fillOpacity: 0.92
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 163.5,
    y: 151,
    width: 13,
    height: 27,
    rx: 2,
    fill: "#E07AA5",
    fillOpacity: 0.92
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 183.5,
    y: 160,
    width: 13,
    height: 18,
    rx: 2,
    fill: "#41414a",
    fillOpacity: 0.55
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 168,
    width: 13,
    height: 10,
    rx: 2,
    fill: "#41414a",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.7b08875884579458a667c503bb4a8f73.svg";
export { ForwardRef as ReactComponent };